export default "* Fodspor\n* Amulet\n* Overtro\n\n";